import { styled } from "@mui/material";
const StyledObfuscatedText = styled("span")`
  filter: ${({ isVisible, size }) => isVisible ? "none" : `blur(${size}px)`};
`;
export {
  StyledObfuscatedText
};
